import PropTypes from 'prop-types';
import { FISHERMAN_BRAND_IDENTITY, GLAMMATIC_BRAND_IDENTITY } from '../constants';
export var GatsbyImagePropType = PropTypes.shape({
  // eslint-disable-next-line react/forbid-prop-types
  gatsbyImageData: PropTypes.shape({})
});
export var IdPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
export var ImagePropType = PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]);
export var ImagesPropType = PropTypes.arrayOf(ImagePropType);
export var BlogPostPropType = PropTypes.shape({
  _id: PropTypes.number,
  title: PropTypes.string.isRequired,
  author: PropTypes.string,
  slug: PropTypes.string.isRequired,
  summary: PropTypes.string,
  publishedAt: PropTypes.string,
  heroImage: PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]),
  heroImageAltText: PropTypes.string
});
export var FloatPropType = PropTypes.oneOf(['left', 'right']);
export var TextAlignPropType = PropTypes.oneOf(['left', 'center', 'right', 'justified']);
export var VerticalAlignPropType = PropTypes.oneOf(['bottom', 'middle', 'top']);
export var DirectionPropType = PropTypes.oneOf(['bottom', 'right', 'top', 'left']);
export var StylePropType = PropTypes.oneOfType([PropTypes.shape({})]);
export var ChildrenPropType = PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.arrayOf(PropTypes.node), PropTypes.arrayOf(PropTypes.element), PropTypes.func]);
export var ObjectPropType = PropTypes.shape({});
export var ObjectPropsPropType = PropTypes.oneOfType([ObjectPropType]);
export var CurrencyNumberPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
export var LinkPropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  slug: PropTypes.string,
  url: PropTypes.string,
  groupName: PropTypes.string,
  navigationPriority: PropTypes.number,
  as: PropTypes.string,
  contentProps: ObjectPropsPropType
});
export var SocialMediaValue = PropTypes.shape({
  type: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  label: PropTypes.string
});
export var CopyrightPropType = PropTypes.shape({
  company: PropTypes.string,
  phrase: PropTypes.string
});
export var WebsiteComponentInteractionPropType = PropTypes.shape({
  id: PropTypes.number,
  displayType: PropTypes.string,
  behaviorType: PropTypes.string,
  url: PropTypes.string,
  enabled: PropTypes.bool,
  style: PropTypes.string,
  label: PropTypes.string
});
export var ContentNodeConfigurationPropType = PropTypes.shape({
  _id: PropTypes.number,
  order: PropTypes.number,
  content: PropTypes.string,
  contentType: PropTypes.string,
  contentName: PropTypes.string
});
export var MenuItemVariationPropType = PropTypes.shape({
  name: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  order: PropTypes.number,
  priceDisplay: PropTypes.string
});
export var MenuItemPropType = PropTypes.shape({
  gatsbyImage: GatsbyImagePropType,
  image: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  variations: PropTypes.arrayOf(MenuItemVariationPropType),
  _id: IdPropType,
  annotations: PropTypes.shape({
    likeCount: PropTypes.number
  }),
  available: PropTypes.bool,
  visible: PropTypes.bool,
  interactions: PropTypes.arrayOf(WebsiteComponentInteractionPropType)
});
export var MenuCategoryPropType = PropTypes.shape({
  _id: IdPropType,
  items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.arrayOf(MenuItemPropType)]),
  name: PropTypes.string,
  description: PropTypes.string,
  interactions: PropTypes.arrayOf(WebsiteComponentInteractionPropType)
});
export var ModifierSetPropType = PropTypes.shape({
  _id: IdPropType,
  modifiers: PropTypes.arrayOf(IdPropType),
  name: PropTypes.string,
  description: PropTypes.string,
  minAllowed: PropTypes.number,
  maxAllowed: PropTypes.number
});
export var ModifierPropType = PropTypes.shape({
  _id: IdPropType
});
export var MenuPropType = PropTypes.shape({
  schedules: PropTypes.arrayOf(PropTypes.shape({})),
  categories: PropTypes.arrayOf(MenuCategoryPropType),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  modifierSets: PropTypes.arrayOf(ModifierSetPropType),
  modifiers: PropTypes.arrayOf(ModifierPropType)
});
export var PagesPropType = PropTypes.arrayOf(PropTypes.shape({
  pages: PropTypes.arrayOf(PropTypes.shape({
    pageTitle: PropTypes.string,
    internal: PropTypes.bool,
    slug: PropTypes.string
  }))
}));
export var ServicePropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  description: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  linkContent: PropTypes.string
});
export var SubscribePropType = PropTypes.shape({
  header: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
});
export var HourOfOperationPropType = PropTypes.shape({
  day: PropTypes.number.isRequired,
  open: PropTypes.number.isRequired,
  close: PropTypes.number.isRequired,
  label: PropTypes.string
});
export var CTAPropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  internal: PropTypes.bool.isRequired
});
export var AddressPropType = PropTypes.shape({
  street: PropTypes.string,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  country: PropTypes.string,
  location_name: PropTypes.string
});
export var LocationPropType = PropTypes.shape({
  _id: IdPropType,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  hours: PropTypes.arrayOf(HourOfOperationPropType),
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipCode: PropTypes.string,
  country: PropTypes.string,
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string
  }))
});
var SiteNavigationChildLinkPropTypeShape = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string,
  groupName: PropTypes.string,
  pageType: PropTypes.string,
  url: PropTypes.string,
  tagName: PropTypes.string,
  navigationOrder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  navigationGroup: PropTypes.string,
  // used in PopupAccordionMenuLink grouping
  navigationGroupOrder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) // used in PopupAccordionMenuLink grouping
};
SiteNavigationChildLinkPropTypeShape.childPages = PropTypes.arrayOf(PropTypes.shape(SiteNavigationChildLinkPropTypeShape));
export var SiteNavigationLinkPropType = PropTypes.shape({
  _id: IdPropType,
  title: PropTypes.string.isRequired,
  pageType: PropTypes.string,
  slug: PropTypes.string,
  url: PropTypes.string,
  groupName: PropTypes.string,
  navigationPriority: PropTypes.number,
  as: PropTypes.string,
  navigationOrder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  navigationGroup: PropTypes.string,
  // used in PopupAccordionMenuLink grouping
  navigationGroupOrder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // used in PopupAccordionMenuLink grouping
  childPages: PropTypes.arrayOf(PropTypes.shape(SiteNavigationChildLinkPropTypeShape))
});
export var SiteNavigationLinkGroupsPropType = PropTypes.objectOf(PropTypes.arrayOf(SiteNavigationLinkPropType));
export var AsPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]);
export var BusinessPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['restaurant', 'generic', 'merchant']).isRequired,
  name: PropTypes.string.isRequired,
  leadSource: PropTypes.string.isRequired,
  leadChannel: PropTypes.string.isRequired,
  collectionMethod: PropTypes.string,
  productType: PropTypes.string
});
export var CartItemPropType = PropTypes.shape({
  selectedVariation: PropTypes.shape({
    id: PropTypes.number,
    menu_item: PropTypes.number,
    name: PropTypes.string,
    order: PropTypes.number,
    price: PropTypes.number
  }),
  selectedModifiers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    price: PropTypes.number,
    modifierSetId: PropTypes.number
  })),
  specialInstructions: PropTypes.string,
  quantity: PropTypes.number
});
export var CartPropType = PropTypes.shape({
  isOpen: PropTypes.bool,
  items: PropTypes.arrayOf(CartItemPropType),
  addItem: PropTypes.func,
  removeItem: PropTypes.func,
  updateItem: PropTypes.func,
  containsItem: PropTypes.func,
  clearCart: PropTypes.func,
  getItemIndex: PropTypes.func
});
export var PlanPropType = PropTypes.shape({
  title: PropTypes.string,
  monthly: PropTypes.shape({
    price: PropTypes.number
  })
});
export var CarPropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
  items: PropTypes.arrayOf(PropTypes.shape({})),
  addItem: PropTypes.func,
  removeItem: PropTypes.func,
  updateItem: PropTypes.func,
  containsItem: PropTypes.func,
  clearCart: PropTypes.func,
  getItemIndex: PropTypes.func
})]);
export var FieldTypePropType = PropTypes.shape({
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool
});
export var LocationAddressPropType = PropTypes.shape({
  street_address: PropTypes.string,
  extended_address: PropTypes.string,
  region: PropTypes.string,
  locality: PropTypes.string,
  sub_locality: PropTypes.string,
  administrative_area_level_1: PropTypes.string,
  administrative_area_level_2: PropTypes.string,
  administrative_area_level_3: PropTypes.string,
  postal_code: PropTypes.string,
  country: PropTypes.string,
  url: PropTypes.string
});
export var OrderPropType = PropTypes.shape({
  order_turnaround_time: PropTypes.string,
  location_address: LocationAddressPropType
});
export var BrandPropType = PropTypes.oneOf([FISHERMAN_BRAND_IDENTITY, GLAMMATIC_BRAND_IDENTITY]);